import { render, staticRenderFns } from "./WalletTransactionType.vue?vue&type=template&id=20e72786&"
import script from "./WalletTransactionType.vue?vue&type=script&lang=js&"
export * from "./WalletTransactionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports